export default "__VITE_ASSET__Cd41LagQ__"